var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#CC6058",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.332 49.334L50.332 51.8525L50.332 72.0007",
    stroke: "#CC6058",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.668 49.334L61.668 51.8525L61.668 72.0007",
    stroke: "#CC6058",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8346 40.834L73.0013 78.0215C73.0013 79.4304 72.4043 80.7817 71.3416 81.778C70.2789 82.7743 68.8375 83.334 67.3346 83.334H44.668C43.1651 83.334 41.7237 82.7743 40.661 81.778C39.5983 80.7817 39.0013 79.4304 39.0013 78.0215L36.168 40.834H75.8346Z",
    stroke: "#CC6058",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 27.666V34.166C47.5 34.7183 47.9477 35.166 48.5 35.166H63.5C64.0523 35.166 64.5 34.7183 64.5 34.166V27.666C64.5 27.1137 64.0523 26.666 63.5 26.666H48.5C47.9477 26.666 47.5 27.1137 47.5 27.666Z",
    stroke: "#CC6058",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 35.666V40.3327C33.332 40.6088 33.5559 40.8327 33.832 40.8327H78.1654C78.4415 40.8327 78.6654 40.6088 78.6654 40.3327V35.666C78.6654 35.3899 78.4415 35.166 78.1654 35.166H33.832C33.5559 35.166 33.332 35.3899 33.332 35.666Z",
    stroke: "#CC6058",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1311c6fa2663379cd7d4421634fa5f62.svg";
export { ForwardRef as ReactComponent };